import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Formik } from "formik";

const Question10 = ({ name, lang }) => {
  const [question10, setQuestion10] = useState(null);

  const handleQuestionChange = (e, setFieldValue) => {
    setFieldValue("question10", e.target.dataset.name);
    if (JSON.parse(localStorage.getItem("rateMyBossDetails"))) {
      let existingDetails = JSON.parse(
        localStorage.getItem("rateMyBossDetails")
      );

      Object.assign(existingDetails, {
        question10: e.target.dataset.name,
      });

      localStorage.setItem(
        "rateMyBossDetails",
        JSON.stringify(existingDetails)
      );
    }
  };

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("rateMyBossDetails"))) {
      setQuestion10(
        JSON.parse(localStorage.getItem("rateMyBossDetails")).question10
      );
    }
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <Formik
            initialValues={{
              question10: question10 ? question10 : "",
            }}
            enableReinitialize={true}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
            }}
          >
            {({
              values,
              errors,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <div>
                {lang && lang === "spanish" ? (
                  <form className="rate_my_boss_form" onSubmit={handleSubmit}>
                    <div>
                      <p>
                        {" "}
                        <b>Q10</b>&nbsp;&nbsp;&nbsp;{" "}
                        <b>
                          <i>{name}</i>
                        </b>{" "}
                        &nbsp; se asegura de que tengo la autoridad necesaria
                        para llevar a cabo mis responsabilidades laborales
                        conocidas.
                      </p>
                    </div>

                    <div
                      className="row"
                      style={{
                        marginTop: "70px",
                      }}
                    >
                      <div className="col-md-10">
                        <Form.Group className="row">
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question10"
                                  id="never"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"never"}
                                  value={"never"}
                                  checked={values.question10 === "never"}
                                />{" "}
                                Nunca
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question10"
                                  id="sometimes"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"sometimes"}
                                  value={"sometimes"}
                                  checked={values.question10 === "sometimes"}
                                />{" "}
                                A veces
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question10"
                                  id="often"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"often"}
                                  value={"often"}
                                  checked={values.question10 === "often"}
                                />{" "}
                                A menudo
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question10"
                                  id="always"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"always"}
                                  value={"always"}
                                  checked={values.question10 === "always"}
                                />{" "}
                                Siempre
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </form>
                ) : (
                  <form className="rate_my_boss_form" onSubmit={handleSubmit}>
                    <div>
                      <p>
                        {" "}
                        <b>Q10</b>&nbsp;&nbsp;&nbsp;{" "}
                        <b>
                          <i>{name}</i>
                        </b>{" "}
                        &nbsp; ensures I have the necessary authority to
                        undertake my known work accountabilities.
                      </p>
                    </div>

                    <div
                      className="row"
                      style={{
                        marginTop: "70px",
                      }}
                    >
                      <div className="col-md-10">
                        <Form.Group className="row">
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question10"
                                  id="never"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"never"}
                                  value={"never"}
                                  checked={values.question10 === "never"}
                                />{" "}
                                Never
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question10"
                                  id="sometimes"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"sometimes"}
                                  value={"sometimes"}
                                  checked={values.question10 === "sometimes"}
                                />{" "}
                                Sometimes
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question10"
                                  id="often"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"often"}
                                  value={"often"}
                                  checked={values.question10 === "often"}
                                />{" "}
                                Often
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-check">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="question10"
                                  id="always"
                                  onChange={(e) =>
                                    handleQuestionChange(e, setFieldValue)
                                  }
                                  data-name={"always"}
                                  value={"always"}
                                  checked={values.question10 === "always"}
                                />{" "}
                                Always
                                <i className="input-helper"></i>
                              </label>
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Question10;
